<template>
    <modal
        :saveAction="save"
        :title="$t(title)"
        :scrollable="true"
        :id="id"
        :actionButtons="!hideForm"
        size="xl"
        :closeButton="hideForm"
        @shown="shown"
        @hidden="hidden"
    >
        <div class="card mb-3" v-for="(appointment, appointmentIDX) in appointments" :key="appointmentIDX">
            <div class="card-body p-3">
                <div class="row align-items-center">
                    <div class="col-auto mr-0 pr-0">
                        <i class="fe fe-calendar text-muted"></i>
                    </div>
                    <div
                        class="col-auto pointer"
                        id="calendar"
                        @click="openDatePicker('calendar', appointmentIDX)"
                    >{{ appointment.appointmentAt | moment('dddd, Do MMMM ') }}
                    </div>

                    <div class="col">
                        {{ appointment.startAt | moment(' h:mm a') }}
                        <span
                            v-if="appointment.endAt"
                        >- {{ appointment.endAt | moment(' h:mm a') }}</span>
                    </div>
                    <div class="order-md-1 order-0 col-auto">
                        <button
                            class="btn btn-white d-lg-inline-block mr-1"
                            @click="addAppointment(appointmentIDX)"
                        >
                            <i class="fe fe-plus"></i>
                        </button>
                        <confirmable-button
                            style="display:inline;"
                            buttonClass="btn btn-white d-lg-inline-block mr-2"
                            v-if="appointmentIDX!==0"
                            @confirm="deleteAppointment(appointmentIDX)"
                        >
                            <i class="fe fe-trash"></i>
                        </confirmable-button>
                    </div>
                </div>
            </div>


            <div class="card mb-3" v-if="appointment.appointmentAt">
                <div class="card-body p-3">
                    <div v-for="(service, index) in appointment.services" :key="index">
                        <div class="row align-items-end mb-md-0 mb-lg-2 entry-services">
                            <div v-if="index > 0" class="col-12 d-md-block d-lg-none">
                                <hr>
                            </div>
                            <div class="col-md-6 col-lg mb-md-3 mb-lg-0">
                                <label class="d-md-inline-block" :class="index !== 0 ? 'd-lg-none':''">{{
                                        $t('Staff')
                                    }}</label>
                                <team-select tabindex="5" multiple mode="tree" v-model="users[appointmentIDX]" idOnly></team-select>
                            </div>

                            <div class="col-md col-lg-auto mb-md-3 mb-lg-0 entry-services__appointment">
                                <label class="d-md-inline-block" :class="index !== 0 ? 'd-lg-none':''">{{
                                        $t('Start at')
                                    }}</label>
                                <hours
                                    v-model="service.startAt"
                                    :base="appointment.appointmentAt"
                                    :schedule="workingHours(service)"
                                    :disabled="!service.userId"
                                    :blocked="findSlots(appointmentIDX,service)"
                                    @change="calculateEndDate(appointmentIDX,null, index);"
                                ></hours>
                                {{ service.disabledHours }}
                            </div>
                            <div class="col-md col-lg-auto mb-md-3 mb-lg-0 entry-services__duration">
                                <label class="d-md-inline-block" :class="index !== 0 ? 'd-lg-none':''">{{
                                        $t('Duration')
                                    }}</label>
                                <duration-field
                                    v-model="service.duration"
                                    @change="calculateEndDate(appointmentIDX,null, index)"
                                    :state="durationFieldState(service)"
                                ></duration-field>
                            </div>
                        </div>
                        <div class="row align-items-center mt-2" v-if="hasBuffer(service)">
                            <div class="col">
                                <div class="card card-inactive p-1 text-center mb-0 text-muted text-sm">
                                    <small>{{ service.treatment.bufferDuration | duration }} {{
                                            $t('service time')
                                        }}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="card border-0 mb-0">
                        <div class="card-body p-3">
                            <div class="row mb-3">
                                <div class="col-12">
                                    <div class="form-group mb-0">
                                        <label>{{ $t('Notes') }}</label>
                                        <b-form-textarea ref="note" v-model.trim="appointment.notes"></b-form-textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <date-picker
                class="invisible position-fixed"
                :label="$t('Date')"
                :calendarOptions="calendarOptions"
                v-model="appointment.appointmentAt"
                :ref="'datePickerWrap_'+appointmentIDX"
            ></date-picker>
        </div>

        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col">
                        <!-- <button class="btn btn-white mr-2" @click="data.notify = !data.notify">
                            <i class="fe fe-bell" v-if="!data.notify"/>
                            <i class="fe fe-bell-off" v-else/>
                        </button> -->
                    </div>
                    <div class="col-auto">
                        <button type="button" @click="close" class="btn btn-white mr-2">{{ $t('Cancel') }}</button>
                        <button type="button" :disabled="saveButtonState" @click="save" class="btn btn-primary">
                            {{ $t('Save') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>

    </modal>
</template>


<script>

import Repeat from "@/components/Repeat.vue";
import Modal from "@/components/Modal.vue";
import Hours from "@/components/Hours.vue";
import Avatar from '@/components/Avatar.vue'

import DurationField from '@/components/DurationField.vue'
import TeamSelect from '@/components/TeamSelect.vue'
import DatePicker from '@/components/DatePicker.vue'
import {mapActions, mapGetters, mapState} from 'vuex';
import ServicesSelect from "@/components/ServicesSelect.vue";
import ServiceSelect2 from "@/components/ServiceSelect2.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";

import CustomerField from "@/components/CustomerField.vue";
import duration from '@/filters/duration';


import AppointmentNotification from "@/components/TimeTemplates/AppointmentNotification";
import WorkPlaceSelect from "@/Pages/Company/WorkPlaces/WorkPlaceSelect";
import Money from '@/components/Money';
import ConfirmableButton from "../../components/ConfirmableButton";

export default {
    name: 'block-appointment-time-modal',
    props: ['id'],
    filters: {duration},
    components: {
        WorkPlaceSelect,
        AppointmentNotification,
        Money,
        Modal,
        Hours,
        Repeat,
        Avatar,
        DatePicker,
        CustomSwitch,
        TeamSelect,
        CustomerField,
        DurationField,
        ServicesSelect,
        ServiceSelect2,
        ConfirmableButton
    },

    data() {
        return {
            enable: {
                notes: false
            },
            currentFocus: 0,
            selectedValue: null,
            loading: false,
            hideForm: false,
            errors: {},
            title: 'Block The Time',
            appointments: [],
            log: {},
            newCustomer: {
                name: null,
                phone: null,
                birth_date: null,
                gender: null
            },

            notificationOptionTypes: [
                {text: 'Minutes', value: 'minutes'},
                {text: 'Hours', value: 'hours'},
                {text: 'Days', value: 'days'},
            ],
            params: {
                query: {
                    $limit: 20,
                }
            },
            users: [],
            calendarOptions: {},
            selectedDate: null,
            saveButtonState: false,
            model: {
                customerId: null
            }
        }
    },
    watch: {
        appointments: {
            handler(newVal) {
                this.saveButtonState = this.isSaveDisabled()
            },
            deep: true
        }
    },

    computed: {
        ...mapState('auth', ['user']),
        ...mapState('my-team', {isTeamLoading: 'isFindPending'}),
        ...mapGetters('my-team', {findTeamInStore: 'find', getUser: 'get'}),
        ...mapGetters('appointment', {findAppointments: 'find'}),
        ...mapState('customers', {areCustomersLoading: 'isFindPending'}),
        ...mapGetters('work-place', {findWorkplaces: 'find'}),


        ...mapGetters('customers', {
            findItemsInStore: 'find',
            getCustomer: 'get'
        }),

        customer() {
            return this.getCustomer(this.newCustomer.customerId);
        },
        workplaces() {
            return this.findWorkplaces().data;
        },
    },

    methods: {
        ...mapActions('appointment', ['find', 'create', 'patch']),
        ...mapActions('customers', {fetchCustomer: 'get', find: 'find', createCustomer: 'create'}),

        durationFieldState(item) {
            if (!item.treatment)
                return null
            if (!item.duration)
                return false
        },

        findItems() {
            this.find(this.params);
        },

        openDatePicker(position, appointmentIDX) {
            const flatPickrInstance = this.$refs['datePickerWrap_' + appointmentIDX][0].$refs.datePickerWrap.fp;
            flatPickrInstance._positionElement = window.document.getElementById(position); // eslint-disable-line
            flatPickrInstance.open();
        },

        findSlots(appointmentIDX, service) {
            if (!service.userId) return false;
            let queryParams = {
                query: {
                    status: { $nin: ['completed', 'cancelled'] },
                    startAt: {
                        $gt: this.$moment(this.appointments[appointmentIDX].appointmentAt).startOf('day'),
                        $lt: this.$moment(this.appointments[appointmentIDX].appointmentAt).endOf('day'),
                    }
                }
            };

            queryParams.query['services.userId'] = service.userId;

            let result = this.findAppointments(queryParams).data;

            let disabledHours = [];
            result.forEach(appointment => {
                appointment.services.forEach(serviceItem => {
                    disabledHours.push(
                        {
                            start: serviceItem.startAt,
                            end: this.$moment(serviceItem.startAt).add(service.duration, 'minute'),
                        }
                    );
                })
            });
            return disabledHours;
        },

        duration(duration) {
            return this.$moment().startOf('day').add(duration, 'minutes');
        },

        workingHours(service) {
            if (!service.userId) return;
            return this.getUser(service.userId).schedule;
        },

        isSaveDisabled() {
            if (!this.appointments.length)
                return true
            return this.appointments.some(appointment => {
                if (!appointment.services || !appointment.startAt)
                    return true
                return appointment.services.some(el => !el.duration)
            })
        },

        servicesParams(service) {
            if (!service.userId)
                return;
            let treatmentIds = this.getUser(service.userId).treatments;
            return {query: {_id: {$in: treatmentIds}}}
        },

        calculateEndDate(appointmentIDX, service) {
            if (service) {
                this.setServiceDuration(service);
            }
            let item = this.appointments[appointmentIDX].services[0];
            this.appointments[appointmentIDX].startAt = item.startAt;

            this.appointments[appointmentIDX].duration = item.duration;
            this.appointments[appointmentIDX].endAt =
                this.$moment(this.appointments[appointmentIDX].startAt).add(item.duration, 'minute');
        },

        setServiceDuration(service) {
            if (service.treatment) {
                this.$set(service, 'duration', service.treatment.duration);
            }
        },

        hasBuffer(service) {
            return (service.treatment && service.treatment.bufferDuration > 0)
        },

        addNotification(index) {
            this.data.notifications.splice(index + 1, 0, {});
        },

        removeNotification(index) {
            this.data.notifications.splice(index, 1);
        },

        addService(appointmentIDX) {
            let initial = {quantity: 1, startAt: this.appointments[appointmentIDX].endTime};
            const length = this.appointments[appointmentIDX].services.length;
            if (length >= 1) {
                initial.userId = this.appointments[appointmentIDX].services[length - 1].userId
            }
            this.appointments[appointmentIDX].services.push(initial);
        },

        removeService(appointmentIDX, index) {
            this.appointments[appointmentIDX].services.splice(index, 1);
            this.calculateEndDate();
        },

        hidden() {
            // Object.assign(this.model, this.data);
            // this.model.startAt = null;
            this.appointments = [];
            this.users = [];
            this.errors = {};
            this.model = {};
            this.newCustomer = {};
        },

        shown() {
            const {Appointment} = this.$FeathersVuex;
            let data = Appointment.getFromStore('temp');

            if (data) {
                delete data._id;
                Object.assign(this.model, data.model);

                new Appointment({
                    _id: 'temp'
                });
            }
            if (this.model.startAt) {
                this.model.appointmentAt = this.$moment(this.model.startAt).local().format('YYYY-MM-DD');
            }
            if (!this.model._id) {
                this.model.notify = false;
                this.model.services[0].quantity = 1;
            }

            !this.model.services[0].userId
                ? this.model.services[0].userId = (this.user || {})._id : null

            this.model.customerId = this.model.customerId || null;
            if (this.model.customerId) {
                this.fetchCustomer(this.model.customerId);
                this.$set(this.newCustomer, 'customerId', this.model.customerId);
            }

            if (!this.model.services[0].duration){
                if (!this.model.endAt) {
                    this.model.endAt = this.$moment(this.model.startAt).add(60, 'minute')
                    this.model.services[0].duration = 60
                    this.model.duration = 60
                } else {
                    const now = this.$moment(this.model.endAt)
                    const end = this.$moment(this.model.startAt)
                    const duration = Math.trunc(this.$moment.duration(now.diff(end)).asMinutes())
                    this.model.services[0].duration = duration
                    this.model.duration = duration
                }
            }

            let copy = this.$copy(this.model);
            let service = copy.services[0]
            copy.services = [service]
            this.appointments.push(copy);

            this.users[0] = this.model.services.map((service)=>{
                return service.userId
            })
        },

        validation(field) {
            //const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;

            if (this.errors && this.errors[field])
                return false
            else
                return null
        },

        saveOne(appointment) {

            this.errors = {};
            let service = appointment.services[0]
            let data = {
                startAt: appointment.startAt,
                endAt: appointment.endAt,
                repeat: appointment.repeat,
                isBlocker: true,
                timeTemplate: appointment.timeTemplate,
                notify: appointment.notify,
                services: this.users[
                    this.appointments.indexOf(appointment)
                    ].map(user => {
                    return {
                        userId: user,
                        startAt: service.startAt,
                        quantity: service.quantity ? service.quantity : 1,
                        duration: service.duration,
                        workPlaceId: service.workPlaceId
                    }
                }),
                notes: appointment.notes,
                status: "new"
            };

            let promise, successMessage;

            if (appointment._id) {
                promise = this.patch([appointment._id, data]);
                successMessage = this.$t('Appointment has been saved');
            } else {
                promise = this.create(data);
                successMessage = this.$t('Appointment has been created');
            }

            return promise
        },

        save() {
            let promises = this.appointments.map((appointment) => {
                return this.saveOne(appointment)
            })

            Promise.all(promises).then(() => {
                this.close()
                this.$toasted.global.success({
                    message: this.$t('Appointment has been saved')
                });
            }).catch(e => {
                console.log('errors', e);
                this.errors = e.errors;
            });
        },

        addAppointment(appointmentIDX) {
            let appointment = this.$copy(this.appointments[appointmentIDX]);
            appointment.appointmentAt = this.$moment(appointment.appointmentAt).add(1, 'day').format('YYYY-MM-DD');
            appointment.startAt = this.$moment(appointment.startAt).add(1, 'day');
            appointment.services.forEach(element => {
                element.startAt = this.$moment(element.startAt).add(1, 'day');
            });
            this.users[appointmentIDX + 1] = this.users[appointmentIDX]
            this.appointments.splice(appointmentIDX + 1, 0, appointment);
            this.calculateEndDate(appointmentIDX + 1)

        },
        deleteAppointment(appointmentIDX) {
            this.appointments.splice(appointmentIDX, 1);
        },

        close() {
            this.$root.$emit('bv::hide::modal', this.id);
        }
    },

}
</script>

<style lang="scss">
.entry-services {
    @media (min-width: 992px) {
        &__duration,
        &__appointment {
            width: 120px;
        }
        &__work-place {
            width: 130px;
        }
    }
}
</style>
